module.exports = __webpack_public_path__ + "img/88.8ae4810b.jpg";